import React from 'react';
import { Mail, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-white py-6 md:py-8 border-t border-white/10" data-id="element-115">
      <div className="max-w-5xl mx-auto px-4 flex flex-col items-center text-center gap-2 md:gap-3" data-id="element-116">
        <div className="flex items-center gap-2 text-sm md:text-base text-blue-100 font-bold" data-id="element-117">
          <span data-id="element-118">🧠</span> MEGAPACK GUARDIA PSIQUIÁTRICA PRO™
        </div>

        <p className="text-[11px] md:text-xs text-gray-400 max-w-md leading-snug" data-id="element-119">
          El sistema de guardia psiquiátrica N°1 para el hospital público
          argentino.
        </p>

        <div className="flex items-center gap-4 mt-1 text-[11px] md:text-xs text-gray-300" data-id="element-120">
          <a href="mailto:contacto@mundodigitalarg.com" className="flex items-center gap-1 hover:text-white transition-colors" data-id="element-121">
            <Mail className="w-3 h-3" data-id="element-122" /> contacto@mundodigitalarg.com
          </a>
          <a href="#" className="flex items-center gap-1 hover:text-white transition-colors" data-id="element-123">
            <Instagram className="w-3 h-3" data-id="element-124" /> @mundodigitalarg
          </a>
        </div>

        <div className="text-[10px] text-gray-500 mt-2 md:mt-3" data-id="element-125">
          © mundodigitalarg™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}